<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M3.75 1.25C2.37109 1.25 1.25 2.37109 1.25 3.75V16.25C1.25 17.6289 2.37109 18.75 3.75 18.75H16.25C17.6289 18.75 18.75 17.6289 18.75 16.25V3.75C18.75 2.37109 17.6289 1.25 16.25 1.25H3.75ZM3.94531 7.89844H6.54297V16.25H3.94531V7.89844ZM6.74609 5.25391C6.74609 6.08594 6.07422 6.75781 5.24219 6.75781C4.41016 6.75781 3.73828 6.08594 3.73828 5.25391C3.73828 4.42188 4.41016 3.75 5.24219 3.75C6.07422 3.75 6.74609 4.42188 6.74609 5.25391ZM13.668 16.25V12.1875C13.668 11.2188 13.6484 9.97266 12.3203 9.97266C10.9688 9.97266 10.7617 11.0273 10.7617 12.1172V16.25H8.16797V7.89844H10.6562V9.03906H10.6914C11.0391 8.38281 11.8867 7.69141 13.1484 7.69141C15.7734 7.69141 16.2617 9.42188 16.2617 11.6719V16.25H13.668Z"
			:fill="computedFill"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconLinkedin',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
